import http from 'apis/config/http-service';
import { useQueryWrapper } from 'apis/config/use-api-wrapper';
import type { AxiosError } from 'axios';
import { UseQueryOptions, UseQueryResult } from 'react-query';
import type { SupplierUserSummary } from './types';
import { restaurantInquiriesEndpoint } from './use-create-restaurant-inquiry-api';

// GET api/v1/cms/restaurant-inquiries/suppliers/:supplierId/users — active users
// of a supplier, for the Send Order SAM dropdown. Small list, no pagination.
type TData = SupplierUserSummary[];
type TError = AxiosError;
type TQueryKey = [string, number | undefined];
type Options = Omit<UseQueryOptions<TData, TError, TData, TQueryKey>, 'queryKey' | 'queryFn'>;

export function useGetInquirySupplierUsersApi(supplierId?: number, options?: Options): UseQueryResult<TData, TError> {
  const queryFn = async (): Promise<TData> => {
    const response = await http.get(`${restaurantInquiriesEndpoint}/suppliers/${supplierId}/users`);
    return response.data?.data ?? response.data ?? [];
  };

  return useQueryWrapper([`${restaurantInquiriesEndpoint}/supplier-users`, supplierId], queryFn, {
    enabled: !!supplierId,
    ...options,
  });
}
